import React from "react";
import { Image } from "react-bootstrap";
import { Facility, Opportunity, TimeLeft } from '../types/type';

// interface OpportunityStructure {
//     id: number,
//     due: string,
//     close_data: Date,
//     company_id: number,
//     name: string,
//     industry: string,
//     bids: {
//         bid_id: number,
//         status: number,
//         upload_file_path: string,
//         upload_file_name: string
//     }[];
// }

// interface OpportunityStructure {
//     id: number,
//     due: number,
//     close_date: number,
//     company_id: number,
//     name: string,
//     industry: string,
//     bid_id: number,
//     status: number,
//     upload_file_path: string,
//     upload_file_name: string
// }

// interface Facility {
//     id: number,
//     due: string,
//     created: string,
//     company_name: string,
//     industry: string,
//     facility_id: number,
//     name: string,
//     contract_start_date: string,
//     pref: string,
//     address: string,
//     supplier_id: number,
//     supplier_name: string,
//     contract_type: string,
//     category: string,
//     usage_total: number,
//     contract_usage: number,
//     annual_load_factor_p: number,
//     annual_load_factor_h: number,
//     favorite: any,
//     option_4: any,
//     bids_count: number,
// }

// interface Opportunity {
//     id: number;
//     due: number;
//     close_date: number;
//     created: string;
//     company_name: string;
//     industry: string;
//     facility_count: number;
//     usage_total: number;
//     contract_usage: number;
//     min_contract_start_date: string;
//     max_contract_start_date: string;
//     facilities: Facility[];
//     favorite: any;
//     bids_count: number;
// }
// interface Opportunity {
//     id: number,
//     due: number,
//     close_date: number,
//     company_id: number,
//     name: string,
//     industry: string,
//     bid_id: number,
//     status: number,
//     upload_file_path: string,
//     upload_file_name: string
// }



// interface TimeLeft {
//     timeLeft: number;
//     unit: string; // '日' or '時間'
// }


const ProjectTitle: React.FC<{ company: Opportunity }> = ({ company }) => {

    const getTimeLeft = (due: number): TimeLeft => {

        const dueDate = new Date(due * 1000);

        const now = new Date();

        const diff = dueDate.getTime() - now.getTime();

        if (diff < 0) {
            return { timeLeft: 0, unit: "時間" };
        }

        const hoursLeft = Math.round(diff / (60 * 60 * 1000));

        if (hoursLeft > 24) {
            return { timeLeft: Math.round(hoursLeft / 24), unit: "日" };
        }

        return { timeLeft: hoursLeft, unit: "時間" };
    };

    return (
        <div className="project-details mb-lg-5 mb-4">
            <div className="bg-white py-1 px-4 text-orange-02 d-inline-block my-sm-0 my-2 border border-ass ml-2">
                <Image className="height-15 mb-1 mr-1"
                    src="assets/images/other/icon-process-orange.svg" />残り
                {getTimeLeft(company.due).timeLeft}{getTimeLeft(company.due).unit}
            </div>
            <div className="row">
                <div className="col-lg-7 mb-lg-0 mb-4">
                    <div className="d-inline-block">
                        {/*
                                            <Image class="height-40 mb-2 mr-2" src="assets/images/project-details/product-brand.svg" />
                        */}
                    </div>
                    <h1 className="d-inline-block text-xl fw-300">
                        {
                            company.id ? <span className="text-xs">NO. 1{company.id.toString().padStart(4, '0')}</span> : ''
                        }
                        {company.name}</h1>
                </div>
                <div className="col-lg-5 text-lg-right text-center">
                    <Image className="height-65 mr-2" src="assets/images/other/buildings-right.svg" />
                </div>
            </div>
            <div className="border-bottom-5-blue-05"></div>
        </div>
    )
}

export default ProjectTitle;